import { LOCATION_FETCH_REQUEST, LOCATION_FETCH_SUCCESS, LOCATION_FETCH_FAILURE } from './types';

const initialState = {
    loading: false,
    location: {},
    error: ''
}

const location = (state = initialState, action) => {
    switch (action.type) {
        case LOCATION_FETCH_REQUEST:
            return {
                loading: true,
                location: {},
                error: '',
            }
        case LOCATION_FETCH_SUCCESS:
            return {
                loading: false,
                location: action.payload,
                error: ''
            }
        case LOCATION_FETCH_FAILURE:
            return {
                loading: false,
                location: {},
                error: action.payload
            }
        default:
            return state
    }
}

export default location;